import { Link } from "react-router-dom";
const Footer = () => {
  const year = (new Date()).getFullYear();
  return (
    <>
      <footer className="o-footer" role="contentinfo">
          <div className="o-footer-bottom">
              <div className="container">
                  <div className="row mb-0">
                      <ul className="nav">
                          <li className="nav-item"><Link className="nav-link" to={"/"}>© Fondation Orange {year > 2022 && "- " + year }</Link></li>
                          <li className="nav-item"><a className="nav-link" href="#">Mentions legales</a></li>
                          <li className="nav-item"><a className="nav-link" href="#">Mentions legales</a></li>
                          <li className="nav-item"><a className="nav-link" href="#">FAQ</a></li>
                      </ul>
                      <ul className="nav ml-auto">
                        <li className="nav-item"><a className="nav-link btn btn-social btn-instagram" href="#"><span className="sr-only">Instagram</span></a></li>
                        <li className="nav-item"><a className="nav-link btn btn-social btn-linkedin" href="#"><span className="sr-only">Linkedin</span></a></li>
                        <li className="nav-item"><a className="nav-link btn btn-social btn-youtube" href="#"><span className="sr-only">YouTube</span></a></li>
                      </ul>
                  </div>
              </div>
          </div>
          <a href="#" className="o-scroll-up" title="back to top">
            <span className="d-none d-sm-inline-block static"></span>
          </a>
      </footer>
    </>
  );
};

export default Footer;
